import { useState } from "react";
import PropTypes from "prop-types";
import "../Filters.sass";
import AutoPlanStateSelect from "./AutoPlanStateSelect";
import AutoPlanNameSelect from "./AutoPlanNameSelect";

const AutoPlanFilters = ({ previousSelectedPlanIds, previousSelectedStates }) => {
  const [isPlanDropdownDisabled, setisPlanDropdownDisabled] = useState(false);

  const togglePlanDropdown = () => {
    setisPlanDropdownDisabled((isDisabled) => !isDisabled);
  };

  return (
    <>
      <AutoPlanStateSelect
        previousSelectedStates={previousSelectedStates}
        togglePlanDropdown={togglePlanDropdown}
      />
      <div id="filter-plan_names">
        <AutoPlanNameSelect
          isDisabled={isPlanDropdownDisabled}
          previousSelectedPlanIds={previousSelectedPlanIds}
        />
      </div>
    </>
  );
};

AutoPlanFilters.propTypes = {
  previousSelectedPlanIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  previousSelectedStates: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default AutoPlanFilters;
